import { render, staticRenderFns } from "./useCouponPackageLog.vue?vue&type=template&id=2b5a48be&scoped=true&"
import script from "./useCouponPackageLog.vue?vue&type=script&lang=js&"
export * from "./useCouponPackageLog.vue?vue&type=script&lang=js&"
import style0 from "./useCouponPackageLog.vue?vue&type=style&index=0&id=2b5a48be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a48be",
  null
  
)

export default component.exports